import { usePush } from './usePush'
import estilos from './InterruptorPush.module.css'

/**
 * El interruptor de los avisos en el teléfono.
 *
 * Va donde la persona ya está trabajando y no en una pantalla de ajustes: el
 * técnico no va a ir a buscar una configuración, y si no lo enciende, todo lo
 * que se construyó detrás no le sirve a nadie.
 *
 * Cuando ya está encendido casi no se ve —una línea que confirma—, porque a
 * partir de ahí es una cosa menos en la que pensar.
 */
export function InterruptorPush() {
  const { estado, activar, apagar } = usePush()

  if (!estado.soportado) {
    return (
      <p className={estilos.sinSoporte}>
        Este teléfono no puede recibir avisos del sistema. En iPhone hay que instalar la aplicación
        en la pantalla de inicio para que pueda.
      </p>
    )
  }

  if (estado.activo) {
    return (
      <p className={estilos.encendido}>
        Los avisos le llegan a este teléfono.{' '}
        <button type="button" className={estilos.apagar} onClick={() => void apagar()}>
          Apagarlos
        </button>
      </p>
    )
  }

  return (
    <div className={estilos.zona}>
      <div>
        <p className={estilos.titulo}>Avisos en el teléfono</p>
        <p className={estilos.texto}>
          {estado.bloqueado
            ? 'Le dijo que no al navegador. Para volver a permitirlo hay que entrar a los ajustes del sitio en el teléfono.'
            : 'Le suena el teléfono cuando le asignen una orden o le respondan una solicitud, aunque tenga la aplicación cerrada.'}
        </p>
        {estado.error && <p className={estilos.error}>{estado.error}</p>}
      </div>

      {!estado.bloqueado && (
        <button
          type="button"
          className={estilos.activar}
          onClick={() => void activar()}
          disabled={estado.trabajando}
        >
          {estado.trabajando ? 'Activando…' : 'Activar'}
        </button>
      )}
    </div>
  )
}
